import { Navigate } from "react-router-dom";
import { useUserStore } from "entities/user";
import { AccessDenied } from "shared/ui/access-denied";

export const RequireRole = ({ allowedRoles = [], children }) => {
  const { isAuthenticated, role } = useUserStore();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    return <AccessDenied />;
  }

  return children;
};
